import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/store/auth.store';
import type { StaffRole } from '@/types/api.types';

interface Props {
  children: React.ReactNode;
  roles?: StaffRole[];
}

/** Landing page by role: the restricted EVENT_REQUEST role only gets the two-tile entry page. */
export const homeFor = (role?: StaffRole): string => (role === 'EVENT_REQUEST' ? '/admin/inicio' : '/admin/dashboard');

export function AuthGuard({ children, roles }: Props) {
  const { isAuthenticated, user } = useAuthStore();
  const location = useLocation();

  if (!isAuthenticated) return <Navigate to="/login" state={{ from: location }} replace />;
  if (roles && user && user.role !== 'ADMIN' && !roles.includes(user.role)) {
    return <Navigate to={homeFor(user.role)} replace />;
  }
  return <>{children}</>;
}
